import * as React from "react";
import PublicIcon from '@mui/icons-material/Public';
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import { Link } from "@mui/material";
import IconField from "modules/common/components/iconField/iconField";

class Location extends React.Component<ComponentProps, ComponentState> {
  public render() {
    if (!this.props.location && !this.props.locationLink && !this.props.locationLinkLabel)
      return <React.Fragment></React.Fragment>;

    const iconName = "location-icon";
    const publicIcon = <PublicIcon fontSize="small" className={iconName} />;

    return (
      <React.Fragment>
        {
          !!this.props.location &&
          <IconField icon={<LocationOnOutlinedIcon fontSize="small" className={iconName}/>}>
            <div>{this.props.location}</div>
          </IconField>
        }
        {
          !!this.props.locationLinkLabel && !!!this.props.locationLink &&
          <IconField icon={publicIcon}>
            <div>{this.props.locationLinkLabel}</div>
          </IconField>
        }
        {
          !!this.props.locationLink && !!!this.props.locationLinkLabel &&
          <IconField icon={publicIcon}>
            <div>{<Link href={this.props.locationLink} target="_blank" >{this.props.locationLink}</Link>}</div>
          </IconField>
        }
        {
          !!this.props.locationLink && !!this.props.locationLinkLabel &&
          <IconField icon={publicIcon}>
            <div> <Link href={this.props.locationLink} target="_blank" >{this.props.locationLinkLabel}</Link></div>
          </IconField>
        }
      </React.Fragment>
    );
  }
}

interface ComponentProps {
  location: string | undefined;
  locationLink: string | undefined;
  locationLinkLabel: string | undefined;
}

interface ComponentState { }

export default Location;